import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedinLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "6 6 38 38",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M44 38.7222C44 41.6377 41.6377 44 38.7222 44H11.2778C8.36339 44 6 41.6377 6 38.7222V11.2778C6 8.36233 8.36339 6 11.2778 6H38.7222C41.6377 6 44 8.36233 44 11.2778V38.7222Z",
		fill: "#3868AD"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13 20.2917H18.2083V38H13V20.2917ZM15.5885 18.2083H15.5594C14.0052 18.2083 13 17.05 13 15.6031C13 14.125 14.0365 13 15.6187 13C17.2031 13 18.1792 14.125 18.2083 15.6031C18.2083 17.049 17.2031 18.2083 15.5885 18.2083ZM38 38H32.7917V28.5219C32.7917 26.2323 31.5156 24.6698 29.4667 24.6698C27.9031 24.6698 27.0573 25.724 26.6469 26.7427C26.4969 27.1073 26.5417 28.1156 26.5417 28.625V38H21.3333V20.2917H26.5417V23.0167C27.2927 21.8542 28.4688 20.2917 31.4771 20.2917C35.2042 20.2917 37.999 22.6354 37.999 27.8687L38 38Z",
		fill: "white"
	})]
});
export default SvgLinkedinLogo;
